import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerticalPump = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 120,
	height: 146.77,
	viewBox: "0 0 120.0 146.77",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 45.0 6.77 A 20.0 20.0 0.0 0 1 75.0 6.77 L 75.0 96.77 A 20.0 20.0 0.0 0 1 45.0 96.77 Z M 105.0 116.77 A 20.0 20.0 0.0 0 1 105.0 146.77 L 15.0 146.77 A 20.0 20.0 0.0 0 1 15.0 116.77 Z M 111.5 131.77 L 120.0 131.77 M 120.0 121.77 L 120.0 141.77 M 0.0 131.77 L 8.5 131.77 M 0.0 121.77 L 0.0 141.77 M 45.0 96.77 L 75.0 96.77 M 45.0 6.77 L 75.0 6.77",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 58,
			y: 103.27,
			width: 4,
			height: 13.5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgVerticalPump;
